import type { BoxProps } from "@braintrust/braintrust-ui-components";
import { Box, Typography } from "@braintrust/braintrust-ui-components";
import { BidAvatarWithScoreMatch } from "@js/apps/jobs/apps/bids";
import { DateComponent } from "@js/components/date";
import { RouterLink } from "@js/components/link";
import type { EmployerBid } from "@js/types/jobs";
import { DateFormats } from "@js/utils/date/types";

import styles from "./styles.module.scss";

type TalentAvatarAndPersonalDetailsProps = {
  bid: EmployerBid;
  jobRoleName: string;
  hideNamePrefix?: boolean;
  boldedName?: boolean;
  sx?: BoxProps["sx"];
};

export const TalentAvatarAndPersonalDetails = ({
  bid,
  jobRoleName,
  hideNamePrefix,
  boldedName,
  sx,
}: TalentAvatarAndPersonalDetailsProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: "16px",
        alignItems: "center",
        overflow: "hidden",
        ...sx,
      }}
    >
      <RouterLink
        to={bid.freelancer.user.profile_url}
        target="_blank"
        className={styles.avatarLink}
      >
        <BidAvatarWithScoreMatch bid={bid} jobRoleName={jobRoleName} />
      </RouterLink>
      <Box sx={{ overflow: "hidden", wordBreak: "normal" }}>
        <Typography component="p" size="large" multipleEllipsis>
          {!hideNamePrefix && "Talent: "}
          <Typography
            component="span"
            size="large"
            variant={boldedName ? "label" : "paragraph"}
          >
            {bid.freelancer.user.public_name}
          </Typography>
        </Typography>

        <Typography component="p" size="small" color="grey-1">
          Applied on{" "}
          <DateComponent
            date={bid.created}
            format={DateFormats["January 1, 1970"]}
          />
        </Typography>
      </Box>
    </Box>
  );
};
